import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

function PolicyModal({ open, onClose }) {
  const [content, setContent] = useState("");
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!open) return;
    let aborted = false;
    async function load() {
      try {
        // Serve from public folder at runtime
        const res = await fetch("/privacy_policy.md", { cache: "no-cache" });
        if (!res.ok) throw new Error("Failed to load policy");
        const text = await res.text();
        if (!aborted) setContent(text);
      } catch (e) {
        if (!aborted) setError(e.message || "Error loading policy");
      }
    }
    load();
    return () => {
      aborted = true;
    };
  }, [open]);

  if (!open) return null;

  return (
    <div className="policy-backdrop" onClick={onClose}>
      <div className="policy-modal" onClick={(e) => e.stopPropagation()}>
        <div className="policy-header">
          <h2>Privacy Policy</h2>
          <button className="policy-close" onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>
        <div className="policy-body">
          {error ? (
            <div className="policy-error">{error}</div>
          ) : (
            <div className="policy-markdown">
              <ReactMarkdown remarkPlugins={[remarkGfm]}>
                {content}
              </ReactMarkdown>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default function Footer() {
  const [open, setOpen] = useState(false);
  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <span>© Copyright 2025 Counselor Notes</span>
        <button className="linklike" onClick={() => setOpen(true)}>
          Privacy Policy
        </button>
      </div>
      <PolicyModal open={open} onClose={() => setOpen(false)} />
    </footer>
  );
}
// Footer component
